import { render, staticRenderFns } from "./SettingsCategoryTypeForm.vue?vue&type=template&id=604e5f58&scoped=true&"
import script from "./SettingsCategoryTypeForm.vue?vue&type=script&lang=ts&"
export * from "./SettingsCategoryTypeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e5f58",
  null
  
)

export default component.exports